// extracted by css-extract-rspack-plugin
export default {"tagBox":"tagBox-nY_bAX","tag":"tag-czG5bt","empty":"empty-xtOch9"};